





















































import Vue from "vue"
import { Company } from "@/model/entity/company/company"
import CompanyBasicInfo from "@/components/user-administration/CompanyBasicInfo.vue"
import CompanyProducts from "@/components/user-administration/CompanyProducts.vue"
import CompanyOffices from "@/components/user-administration/CompanyOffices.vue"

export default Vue.extend({
  data() {
    return {
      formValid: false,
      officeValid: false
    }
  },
  components: {
    CompanyBasicInfo,
    CompanyProducts,
    CompanyOffices
  },
  props: {
    company: {
      type: Object as () => Company,
      required: true
    },
    hint: {
      type: String,
      required: true
    },
    initialCompanyStatus: {
      type: String,
      required: true
    }
  },
  methods: {
    setFormValid(value: boolean) {
      this.formValid = value
      this.$emit("update:valid", this.formValid && this.officeValid)
    },
    setOfficeValid(value: boolean) {
      this.officeValid = value
      this.$emit("update:valid", this.formValid && this.officeValid)
    }
  }
})
